import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUtilsService } from './http-utils.service';
import { Observable, catchError, map, mergeMap, of } from 'rxjs';
import { JsonConvert } from 'json2typescript';
import { Paging } from '../../model/paging/paging';
import { environment } from '../../../environment/environment';
import { LocationSData, LocationS, LocationSListData } from '../../model/location/location';
import { CountersData } from '../../model/cashback/counters';
import { LocationsCounters, LocationsCountersData } from '../../model/location/counters';
import { LocationsList, LocationsListData } from '../../model/location/location-list';
import { Period, PeriodConverter } from '../../model/location/period';
import { TopTen, TopTenListData, TopTenSingle } from '../../model/ranking/top-ten';
import { InvitationsList, InvitationsListData, SingleInvitations } from '../../model/invitations/invitations';
import { Invitation, InvitationData } from '../../model/invitations/invitation';
import { Bulk } from '../../model/invitations/bulk';
import { UploadFile } from '../../model/csv/uploadfile';
    /**
     * Invio bulk con array di UploadFile (nuovo flusso)
     */
    

@Injectable({
    providedIn: 'root'
})

export class InvitationsService {
    private _url: string = `${environment.baseAPI}/locations-groups/invitations`;
    constructor(private _http: HttpClient, private _httpUtils: HttpUtilsService) { }
    
    GETInvitationsList(paging: Paging, location_id: string): Observable<InvitationsList> | any {
        try {
            return this._httpUtils.getHTTPHeadersAsyncTenantLocation().pipe(
                mergeMap(httpHeaders => {
                    return this._http.get(`${this._url}${paging.getQs()}&location_id=${location_id}`, { headers: httpHeaders }).pipe(
                        map((res: any) => {
                            const jsonConvert: JsonConvert = new JsonConvert();
                            const response: InvitationsListData = jsonConvert.deserializeObject(res, InvitationsListData);
                            if (response.success) {
                                return response;
                            } else {
                                this._httpUtils.handleError(response);
                                return;
                            }
                        }, catchError(err => {
                            if (err.status === 401) { // Unauthorized
                                this._httpUtils.logout();
                            }
                            throw err;
                        })));
                }), catchError(err => {
                    throw err;
                })
            );
        } catch (error) {
            throw error;
        }
    }

    GETInvitation(id: string): Observable<Invitation> | any {
        try {
            return this._httpUtils.getHTTPHeadersAsyncTenantLocation().pipe(
                mergeMap(httpHeaders => {
                    return this._http.get(`${this._url}/${id}`, { headers: httpHeaders }).pipe(
                        map((res: any) => {
                            const jsonConvert: JsonConvert = new JsonConvert();
                            const response: InvitationData = jsonConvert.deserializeObject(res, InvitationData);
                            if (response.success) {
                                return response;
                            } else {
                                this._httpUtils.handleError(response);
                                return;
                            }
                        }), catchError(err => {
                            if (err.status === 401) { // Unauthorized
                                this._httpUtils.logout();
                            }
                            throw err;
                        }));
                }), catchError(err => {
                    throw err;
                })
            );
        } catch (error) {
            throw error;
        }
    }

    POSTInvitation(invitation: any, location_id: string): Observable<Invitation> | any {
        try {
            return this._httpUtils.getHTTPHeadersAsyncTenantLocation().pipe(
                mergeMap(httpHeaders => {
                    return this._http.post(`${this._url}?location_id=${location_id}`, invitation, { headers: httpHeaders }).pipe(
                        map((res: any) => {
                            return res;
                            // const jsonConvert: JsonConvert = new JsonConvert();
                            // const response: Invitation = jsonConvert.deserializeObject(res, Invitation);
                            // return response;
                        }), catchError(err => {
                            if (err.status === 401) { // Unauthorized
                                this._httpUtils.logout();
                            }
                            throw err;
                        }));
                }), catchError(err => {
                    throw err;
                })
            );
        } catch (error) {
            throw error;
        }
    }

    PUTInvitation(id: string, invitation: any): Observable<Invitation> | any {
        try {
            return this._httpUtils.getHTTPHeadersAsyncTenant().pipe(
                mergeMap(httpHeaders => {
                    return this._http.put(`${this._url}/${id}`, invitation, { headers: httpHeaders }).pipe(
                        map((res: any) => {
                            return res;
                            // const jsonConvert: JsonConvert = new JsonConvert();
                            // const response: Invitation = jsonConvert.deserializeObject(res, Invitation);
                            // return response;
                        }), catchError(err => {
                            if (err.status === 401) { // Unauthorized
                                this._httpUtils.logout();
                            }
                            throw err;
                        }));
                }), catchError(err => {
                    throw err;
                })
            );
        } catch (error) {
            throw error;
        }
    }

    DELETEInvitation(id: string): Observable<any> | any {
        try {
            return this._httpUtils.getHTTPHeadersAsyncTenantLocation().pipe(
                mergeMap(httpHeaders => {
                    return this._http.delete(`${this._url}/${id}`, { headers: httpHeaders }).pipe(
                        map((res: any) => {
                            return res;
                        }), catchError(err => {
                            if (err.status === 401) { // Unauthorized
                                this._httpUtils.logout();
                            }
                            throw err;
                        }));
                }), catchError(err => {
                    throw err;
                })
            );
        } catch (error) {
            throw error;
        }
    }

    POSTInvitationSendEmail(id: string): Observable<any> | any {
        try {
            return this._httpUtils.getHTTPHeadersAsyncTenantLocation().pipe(
                mergeMap(httpHeaders => {
                    return this._http.post(`${this._url}/${id}/send-email`, {}, { headers: httpHeaders }).pipe(
                        map((res: any) => {
                            return res;
                        }), catchError(err => {
                            if (err.status === 401) { // Unauthorized
                                this._httpUtils.logout();
                            }
                            throw err;
                        }));
                }), catchError(err => {
                    throw err;
                })
            );
        } catch (error) {
            throw error;
        }
    }

    POSTInvitationBulk(bulk: any, location_id: string): Observable<any> | any {
        try {
            return this._httpUtils.getHTTPHeadersAsyncTenantLocation().pipe(
                mergeMap(httpHeaders => {
                    return this._http.post(`${this._url}/bulk?location_id=${location_id}`, bulk, { headers: httpHeaders }).pipe(
                        map((res: any) => {
                            return res;
                        }), catchError(err => {
                            if (err.status === 401) {
                                this._httpUtils.logout();
                            }
                            throw err;
                        }));
                }), catchError(err => {
                    throw err;
                })
            );
        } catch (error) {
            throw error;
        }
    }
}
